














































import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { openMap } from '@/utils'

export default defineClassComponent<{
  value: any
  showAddress: boolean
  largeName: boolean
}>(
  {
    props: ['value', 'showAddress', 'largeName'],
  },
  ({ props }) =>
    class {
      handleNavigateClick = () => {
        openMap({
          name: props.value.storeName || props.value.merchantName,
          latitude: props.value.latitude || props.value.merchantLatitude,
          longitude: props.value.longitude || props.value.merchantLongitude,
        })
      }

      handleContactClick = () => {
        dcb.makePhoneCall({
          phoneNumber: props.value.storePhone || props.value.merchantTel,
        })
      }
    },
)
